import HomeScreen from './interfaces/screens/Home.vue'
import LoginView from './interfaces/screens/Login.vue'
import NotFoundView from './interfaces/screens/404.vue'

// Import Views - Dash
import DashboardView from './interfaces/views/Dashboard.vue'
import UsersView from './interfaces/views/Users.vue'
import AgentsUpdateView from './interfaces/views/AgentsUpdate.vue'
// import ManageView from './interfaces/views/Manage.vue'
import ManagePSBIOView from './interfaces/views/ManagePSBIO.vue'
// import ConsultaPSBIOView from './interfaces/views/ConsultaPSBIO.vue'
import ConsultaSPIDView from './interfaces/views/ConsultaSPID.vue'
import DeleteView from './interfaces/views/Delete.vue'
// import ExportView from './interfaces/views/Export.vue'
import SubjectAuditView from './interfaces/views/SubjectAudit.vue'
import FraudView from './interfaces/views/Fraud.vue'
// import PsBioInfoView from './interfaces/views/PsBioInfo.vue'
// import PsBioErrorsView from './interfaces/views/PsBioErrors.vue'
// import PsbioTransactions from './interfaces/views/PsbioTransactions.vue'
import FindIDNOrigin from './interfaces/views/FindIDNOrigin.vue'

// Routes
const routes = [
  {
    path: '/biomanager/login',
    component: LoginView
  },
  {
    path: '',
    component: LoginView
  },
  {
    path: '/biomanager',
    component: HomeScreen,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Dashboard',
        meta: {description: 'Visão Geral', requiresAuth: true}
      }, {
        path: 'users',
        component: UsersView,
        name: 'Usuários',
        meta: {description: 'Lista de usuários cadastrados no sistema.', requiresAuth: true}
      // }, {
      //   path: 'manage',
      //   component: ManageView,
      //   name: 'Consulta Biométrica',
      //   meta: {description: 'Consulta as biometrias do CPF digitado.', requiresAuth: true}
      }, {
        path: 'managepsbio',
        component: ManagePSBIOView,
        name: 'Consulta Biométrica na Rede PSBIO',
        meta: {description: 'Consulta as biometrias na rede PSBIO.', requiresAuth: true}
      },
      {
        path: 'findpsbioorigin',
        component: FindIDNOrigin,
        name: 'Consulta Origem do IDN',
        meta: {description: 'Consulta Origem do IDN', requiresAuth: true}
      // }, {
      //   path: 'consultapsbio',
      //   component: ConsultaPSBIOView,
      //   name: 'Consulta Biométrica PSBIO',
      //   meta: {description: 'Consulta as biometrias PSBIO.', requiresAuth: true}
      }, {
        path: 'consultaspid',
        component: ConsultaSPIDView,
        name: 'Consulta Biométrica SPID',
        meta: {description: 'Consulta as biometrias SPID.', requiresAuth: true}
      }, {
        path: 'agentsupdate',
        component: AgentsUpdateView,
        name: 'Atualização de Agentes',
        meta: {
          description: 'Permite aos agentes de registro atualizar o seu próprio cadastro biométrico.',
          requiresAuth: true
        }
      }, {
        path: 'delete',
        component: DeleteView,
        name: 'Exclusão Biométrica',
        meta: {description: 'Exclui as biometrias do CPF digitado.', requiresAuth: true}
      // }, {
      //   path: 'export',
      //   component: ExportView,
      //   name: 'Exportação Biométrica',
      //   meta: {description: 'Exporta as biometrias cadastradas por período.', requiresAuth: true}
      }, {
        path: 'subjectaudit',
        component: SubjectAuditView,
        name: 'Auditoria de Sujeitos',
        meta: {description: 'Pesquisa todos os processos de um CPF específico.', requiresAuth: true}
      }, {
        path: 'fraud',
        component: FraudView,
        name: 'Análise de Fraude',
        meta: {description: 'Pesquisa e lista todas as suspeitas e confimações de Fraude.', requiresAuth: true}
      // }, {
      //   path: 'psbioinfo',
      //   component: PsBioInfoView,
      //   name: 'Status PSBIO',
      //   meta: {description: 'Pesquisa o status de comunicação PSBio de um CPF específico.', requiresAuth: true}
      // }, {
      //   path: 'psbioerrors',
      //   component: PsBioErrorsView,
      //   name: 'Erros PSBIO',
      //   meta: {
      //     description: 'Exibe todos os erros de comunicação  referente aos cadastros biométricos',
      //     requiresAuth: true
      //   }
      // },
      // {
      //   path: 'psbiotransactions',
      //   component: PsbioTransactions,
      //   name: 'Transações PsBIO',
      //   meta: {description: 'Exibe quantidade de transações e teste de comunicação', requiresAuth: true}
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes



// WEBPACK FOOTER //
// ./src/routes.js